import { render, staticRenderFns } from "./DictText.vue?vue&type=template&id=34aa2a20&scoped=true&"
import script from "./DictText.vue?vue&type=script&lang=js&"
export * from "./DictText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aa2a20",
  null
  
)

export default component.exports